export default {
  path: 'categories',
  name: 'stocks.categories',
  component: () => import('@/views/admin/stocks/categories/Index'),
}